import type { ChartLegendItem } from '../ChartLegend'

export const LEGEND_ITEMS: ChartLegendItem[] = [
  { key: 'goal', label: 'Meta de consumo total', color: '#1f1f1f' },
  { key: 'cumulative', label: 'Realizado', color: '#0366dd' },
  { key: 'forecast', label: 'Previsão', color: '#0366dd', dashed: true }
]

export const MIN_POINT_WIDTH = 50
export const Y_AXIS_WIDTH = 80
export const CHART_HEIGHT = 280
export const X_AXIS_HEIGHT = 56

export function buildGradient(
  ctx: CanvasRenderingContext2D,
  chartArea: { top: number; bottom: number },
  strong: boolean
): CanvasGradient {
  const gradient = ctx.createLinearGradient(
    0,
    chartArea.top,
    0,
    chartArea.bottom
  )
  if (strong) {
    gradient.addColorStop(0, 'rgba(3,102,221,0.22)')
    gradient.addColorStop(0.4, 'rgba(3,102,221,0.08)')
    gradient.addColorStop(1, 'rgba(3,102,221,0)')
  } else {
    gradient.addColorStop(0, 'rgba(3,102,221,0.10)')
    gradient.addColorStop(0.45, 'rgba(3,102,221,0.035)')
    gradient.addColorStop(1, 'rgba(3,102,221,0)')
  }
  return gradient
}
